import React from 'react'
import { Tooltip } from '@mui/material'

interface CustomTooltipProps {
  value: string
  children: React.ReactElement
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ value, children }) => {
  if (!value) {
    return children
  }

  const formatTitle = (text: string) => {
    const lines = text.split('\n')
    return (
      <span style={{ whiteSpace: 'pre-wrap' }}>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </span>
    )
  }

  return (
    <Tooltip
      title={formatTitle(value)}
      placement="bottom-start"
      arrow={true}
      disableInteractive={true}
      PopperProps={{
        style: {
          zIndex: 1200,
          pointerEvents: 'none',
        },
      }}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 'none',
            lineHeight: 1.6,
          },
        },
      }}
    >
      <span style={{ display: 'block', width: '100%', height: '100%' }}>
        {children}
      </span>
    </Tooltip>
  )
}

export default CustomTooltip
